import axios from 'axios';
import { ElMessage } from 'element-plus';

// 规范化 baseURL，确保包含 /api 前缀
// 如果通过 nginx 代理，使用相对路径；否则使用绝对路径
const RAW_BASE = process.env.VUE_APP_API_BASE_URL || '';
// 如果为空或相对路径，直接使用 /api；否则拼接 /api
const BASE_URL = RAW_BASE ? 
  (RAW_BASE.endsWith('/api') ? RAW_BASE : `${RAW_BASE}/api`) : 
  '/api';

// 创建axios实例
const api = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // 如果是 FormData，不要设置 Content-Type，让浏览器自动设置（包含 boundary）
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    // 对于某些接口，不自动显示错误消息，让调用方自己处理
    const skipAutoMessage = error.config?.skipAutoMessage;
    
    if (error.response) {
      const { status, data } = error.response;
      
      // 如果设置了 skipAutoMessage，不自动显示错误消息，也不自动清除 token 和跳转
      if (!skipAutoMessage) {
      switch (status) {
        case 401:
          ElMessage.error('登录已过期，请重新登录');
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          window.location.href = '/login';
          break;
        case 403:
          ElMessage.error('权限不足');
          break;
        case 404:
          ElMessage.error('请求的资源不存在');
          break;
        case 500: {
          // 500 错误时，如果有详细错误信息，显示详细信息，否则显示通用错误
          const errorMsg = (data && data.message) ? data.message : '服务器内部错误';
          ElMessage.error(errorMsg);
          break;
        }
        default:
          ElMessage.error((data && data.message) || '请求失败');
      }
      }
    } else {
      if (!skipAutoMessage) {
        ElMessage.error('网络错误，请检查网络连接');
      }
    }
    return Promise.reject(error);
  }
);

export default api; 